// Error text of a failed API call for popups/inline errors. The API answers domain errors with plain text
// (ExceptionLoggingMiddleware); other shapes (ProblemDetails, { error }) must never reach React as object.
export default function apiErrorText(err, fallback) {
  const data = err?.response?.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data && typeof data === 'object') return data.detail || data.title || data.error || fallback;
  if (!err?.response) return 'Keine Verbindung – bitte später erneut versuchen.';
  return fallback;
}
